import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

import { TemplateEditor } from "./component/template-editor";
import { PageLayout } from "../../common/page-layout/page-layout";

export const NewTemplate = () => {
  const intl = useIntl();
  const navigate = useNavigate();

  const buildPaths = () => {
    return [
      {
        link: "/",
        title: intl.formatMessage({ id: "page.welcome.title" }),
      },
      {
        link: "/templates",
        title: intl.formatMessage({ id: "page.templates.title" }),
      },
    ];
  };

  return (
    <PageLayout
      paths={buildPaths()}
      title={intl.formatMessage({ id: "page.newtemplate.title" })}
    >
      <TemplateEditor
        currentTemplate={null}
        onSuccess={(createdTemplate) => {
          navigate(`/edittemplate/${createdTemplate.id}`);
        }}
      />
    </PageLayout>
  );
};
